function fixElement(fix, id) {
    document.getElementById(id).style.position = fix ? "fixed" : null;
    document.getElementById(id).style.top = fix ? "0" : null;
}

export {fixElement};